<template>
  <div class="animated fadeIn">
      <b-card>
          <div slot="header">My Pending Approval/Task 
            <div class="card-header-actions">
                <b-pagination v-show="(todos.total>0)"
                  align="right" style="margin-bottom: -25px !important;"
                  :total-rows="todos.total"
                  :per-page="todos.limit"
                  v-model="todos.page"
                ></b-pagination>
            </div>
          </div>

        <div v-show="(todos.total>0)" style="margin-top:-21px;">
          <b-table
              class="m-0"
              ref="tblTaskTodo"
              responsive striped hover small
              :items="TaskTodo"
              :fields="todoFields"
              :current-page="todos.page"
              :per-page="todos.limit"
              :sort-by.sync="todos.sortBy"
              :sort-desc.sync="todos.sortDesc"
              @row-clicked="selectItem"
            >
          <template v-slot:cell(creatorName)="data">
            {{ data.item.creatorNik}} | {{data.item.creatorName}}
          </template>
          <template v-slot:cell(createdon)="data">
            {{ data.item.createdon | moment("ddd DD-MMM-YYYY hh:mm") }}
          </template>
          </b-table>
        </div>
      </b-card>

      <b-card>
          <div slot="header">My Team's Pending Approval/Task 
            <div class="card-header-actions">
                <b-pagination v-show="(teamtodos.total>0)"
                  align="right" style="margin-bottom: -25px !important;"
                  :total-rows="todos.total"
                  :per-page="todos.limit"
                  v-model="todos.page"
                ></b-pagination>
            </div>
          </div>

        <div v-show="(teamtodos.total>0)" style="margin-top:-21px;">
          <b-table
              class="m-0"
              ref="tblTeamTodo"
              responsive striped hover small
              :items="TeamTodo"
              :fields="teamtodoFields"
              :current-page="teamtodos.page"
              :per-page="teamtodos.limit"
              :sort-by.sync="teamtodos.sortBy"
              :sort-desc.sync="teamtodos.sortDesc"
              @row-clicked="selectItem"
            >
          <template v-slot:cell(creatorName)="data">
            {{ data.item.creatorNik}} | {{data.item.creatorName}}
          </template>
          <template v-slot:cell(createdon)="data">
            {{ data.item.createdon | moment("ddd DD-MMM-YYYY hh:mm") }}
          </template>
          </b-table>
        </div>
      </b-card>
  </div>
</template>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import task from "../apis/task";
import toastr from "mini-toastr";
toastr.init();

export default {
  components: {Loading},
  data() {
    return {
      showFilter: false,
      horizontal: true,
      isLoading:false,
      showReport:false,
      reportUrl: null,
      model:{},
      todos:{
        items:[],
        page: 1,
        limit: 20,
        total: 0,
        sortBy: 'createdon',
        sortDesc: false,
        sortDir:'asc'
      },
      todoFields: [
          {
            key: "wftypekey",
            label: "Task/Approval Name",
            sortable: true
          },
          {
            key: "taskname",
            label: "Task/Approval Description",
          },
          {
            key: "createdby",
            label: "Created By",
            sortable: true
          },
          {
            key: "createdon",
            label: "Created @",
            sortable: true
          },
      ],      
      teamtodos:{
        items:[],
        page: 1,
        limit: 20,
        total: 0,
        sortBy: 'createdon',
        sortDesc: false,
        sortDir:'asc'
      },
      teamtodoFields: [
          {
            key: "crewname",
            label: "Team Name",
            sortable: true
          },
          {
            key: "wftypekey",
            label: "Task/Approval Name",
            sortable: true
          },
          {
            key: "taskname",
            label: "Task/Approval Description",
          },
          {
            key: "createdby",
            label: "Created By",
            sortable: true
          },
          {
            key: "createdon",
            label: "Created @",
            sortable: true
          },
      ],      
    };
  },
  methods: {
   TaskTodo: async function() {
      this.todos.sortDir = this.todos.sortDesc ? "desc" : "asc";
      // this.lkuLoading=true;
      const list = await task.mypending(this.todos);          
      // this.lkuLoading=false;
      // console.log(list);
      return list;
    },    
   TeamTodo: async function() {
      this.teamtodos.sortDir = this.todos.sortDesc ? "desc" : "asc";
      // this.lkuLoading=true;
      const list = await task.teampending(this.teamtodos);          
      // this.lkuLoading=false;
      return list;
    },    
    // async refresh(ctx) {
    //   const list = await task.list(this.todos);          
    //   this.todos.items = list[0];
    //   this.teamtodos.items =list[1];
    //   this.$refs.tblTaskTodo.refresh();
    //   this.$refs.tblTeamTodo.refresh();
    // },
    async refreshMy(ctx) {
      // const list = await task.mypending(this.todos);          
      // this.todos.items = list[0];
      this.$refs.tblTaskTodo.refresh();
    },
    async refreshTeam(ctx) {
      // const list = await task.teampending(this.todos);          
      // this.teamtodos.items =list[1];
      this.$refs.tblTeamTodo.refresh();
    },
    selectItem(item,index) {
      // console.log(item);
          // router.push({name :item.routeName, params: JSON.parse(item.routeParam)});
          router.push({name :'app.approvalfrm', params: { taskkey: item.taskkey, key: item.taskassignkey}});
    },    
     close(){
      router.push({name:"app.modules"});
    },       
  }
};
</script>
